import React from "react";
import ReactDOM from "react-dom/client";
import App from "./app";
import "./index.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./auth/hooks/auth-provider";
import { queryClient } from "./queryClient";
import { ErrorBoundary } from "./components/common/ErrorBoundary";

const Root: React.FC = () => {
  return (
    <React.StrictMode>
      <ErrorBoundary fallback={<p>Une erreur s'est produite</p>}>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
};

ReactDOM.createRoot(document.getElementById("root")!).render(<Root />);
